/**
 * <s-build-pins> — light dismiss for the "Explore the build" hotspot cards.
 * An open pin closes when the shopper taps its X, taps anywhere outside the
 * card (including the photo or another spot on the page), or presses Escape.
 */
class SBuildPins extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };

    this.addEventListener('click', (event) => {
      const close = event.target.closest('[data-pin-close]');
      if (!close) return;
      event.preventDefault();
      const details = close.closest('details');
      if (details) {
        details.open = false;
        details.querySelector('summary')?.focus();
      }
    }, opts);

    document.addEventListener('pointerdown', (event) => {
      const open = this.querySelector('details[open]');
      if (!open) return;
      // Taps on the open pin's own card or button are handled natively.
      if (open.contains(event.target)) return;
      // Tapping another pin opens it; the exclusive <details> group closes this one.
      if (event.target.closest('details summary') && this.contains(event.target)) return;
      open.open = false;
    }, opts);

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = this.querySelector('details[open]');
      if (!open) return;
      open.open = false;
      open.querySelector('summary')?.focus();
    }, opts);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-build-pins')) {
  customElements.define('s-build-pins', SBuildPins);
}
